import styled from '@emotion/styled';
import { Loader } from '@hotjar/hotsauce';
import { Header } from '../shared/header/Header';
import type { Step } from '../shared/header/HeaderStep';
import { Body, Container } from '../shared/shared.styles';

const fakeSteps: Step[] = [
  { id: '1', text: 'manage-subscriptions' },
  { id: '2', text: 'invoice-details' },
  { id: '3', text: 'payment-details' },
  { id: '4', text: 'review-order' },
];

const S = {
  Loader: styled(Loader)`
    flex: 1;
    align-self: center;
  `,
};

export function CheckoutLoader(): JSX.Element {
  return (
    <Container direction="column">
      <Header loading steps={fakeSteps} />
      <Body>
        <S.Loader size="xl" />
      </Body>
    </Container>
  );
}
